function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Button } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import { OverlayTrigger, Popover } from "react-bootstrap";

const HelpButton = ({
  subject,
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Button, _extends({
  style: {
    padding: "0.2rem 0.4rem"
  },
  variant: "outline-info",
  title: `Help${subject ? ` on ${subject}` : ''}`
}, props), /*#__PURE__*/React.createElement(FontAwesome, {
  name: "fas fa-question"
}), children ? /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", children) : null);

export function Help({
  subject,
  placement = 'auto',
  show,
  onToggle,
  children,
  label,
  size = 'sm'
}) {
  const helpPopover = /*#__PURE__*/React.createElement(Popover, {
    id: `help-${subject}`,
    className: "mw-100 overflow-auto shadow-sm",
    style: {
      width: '30rem',
      maxHeight: '90vh'
    }
  }, /*#__PURE__*/React.createElement(Popover.Content, null, children));
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: placement,
    overlay: helpPopover,
    show: show,
    onToggle: onToggle
  }, /*#__PURE__*/React.createElement(HelpButton, {
    subject: subject,
    active: show,
    onClick: () => onToggle(!show),
    size: size
  }, label));
}
export default Help;